import Chart from '../components/MDXComponents/chart'

const ChartWithCategory = ({category}) => {
    const ret = {}
    for (const key in Chart) {
        ret[`Chart${key}`] = ({...props}) => { return Chart[key]({category, ...props}) }
    }
    return ret
}



export default ChartWithCategory